import { ICategoryTile } from "@faire/web-api/indigofair/data/ICategoryTile";
import { ISimpleImageTitle } from "@faire/web-api/indigofair/data/ISimpleImageTitle";

export type CategoryTileAndImageTitleTileType =
  | ISimpleImageTitle
  | ICategoryTile;

export const isSimpleImageTile = (
  tile?: CategoryTileAndImageTitleTileType
): tile is ISimpleImageTitle => {
  return "main_text" in (tile ?? {});
};

export const isCategoryTile = (
  tile?: CategoryTileAndImageTitleTileType
): tile is ICategoryTile => {
  return "category_path_identifier" in (tile ?? {});
};
